import { Api, Dashboard, Http } from '../../../models/index';
import { GetApi } from '../api/index';
import { CacheableResource } from '../CacheableResource';
import { GetResource } from '../GetResource';

export class GetUserDashboards extends CacheableResource<CacheableResource.Params, Dashboard[]> {
    private getApi: GetApi;
    private getResource: GetResource<Api.Rel, Dashboard[]>;

    constructor(http: Http) {
        super() /* istanbul ignore next */;
        this.getApi = new GetApi(http);
        this.getResource = new GetResource<Api.Rel, Dashboard[]>(http);
    }

    protected doExecute(): Promise<Dashboard[]> {
        return this.getApi.execute().then((api) => {
            return this.getResource
                .execute({
                    parent: api,
                    rel: 'dashboards'
                })
                .then((dashboard) => dashboard!);
        });
    }
}
